export default __webpack_public_path__ + "static/media/tulips.6ba1cf94.JPG";